import { Dispatch, ReactNode, SetStateAction, createContext, useEffect, useState } from "react";

import { ProductVariant, getGrossPrice } from "models/productsByAvailabilityModel";

type ProductVariantType = ProductVariant & {
    isExtendedWarranty: boolean;
    isPaintProtection: boolean;
    isExteriorProtection: boolean;
};

export type FinanceCalculatorContextType = {
    selectedWarrantyExtraId: number;
    setSelectedWarrantyExtraId: Dispatch<SetStateAction<number>>;
    warrantyPrice: string;
    setWarrantyPrice: Dispatch<SetStateAction<string>>;

    selectedPaintProtectionExtraId: number;
    setSelectedPaintProtectionExtraId: Dispatch<SetStateAction<number>>;
    paintProtectionPrice: string;
    setPaintProtectionPrice: Dispatch<SetStateAction<string>>;

    selectedExteriorProtectionExtraId: number;
    setSelectedExteriorProtectionExtraId: Dispatch<SetStateAction<number>>;
    exteriorProtectionPrice: string;
    setExteriorProtectionPrice: Dispatch<SetStateAction<string>>;

    updateProductVariants: (product: ProductVariantType) => void;
    productVariants: ProductVariantType[];
};

const defaultValues: FinanceCalculatorContextType = {
    selectedWarrantyExtraId: 0,
    setSelectedWarrantyExtraId: () => {},
    warrantyPrice: "",
    setWarrantyPrice: () => {},
    selectedPaintProtectionExtraId: 0,
    setSelectedPaintProtectionExtraId: () => {},
    paintProtectionPrice: "",
    setPaintProtectionPrice: () => {},
    selectedExteriorProtectionExtraId: 0,
    setSelectedExteriorProtectionExtraId: () => {},
    exteriorProtectionPrice: "",
    setExteriorProtectionPrice: () => {},
    updateProductVariants: () => {},
    productVariants: [],
};

export const FinanceCalculatorContext = createContext<FinanceCalculatorContextType>(defaultValues);

export const FinanceCalculatorProvider = ({ children }: { children: ReactNode }) => {
    const [selectedWarrantyExtraId, setSelectedWarrantyExtraId] = useState<number>(
        defaultValues.selectedWarrantyExtraId
    );
    const [selectedExteriorProtectionExtraId, setSelectedExteriorProtectionExtraId] =
        useState<number>(defaultValues.selectedExteriorProtectionExtraId);
    const [selectedPaintProtectionExtraId, setSelectedPaintProtectionExtraId] = useState<number>(
        defaultValues.selectedPaintProtectionExtraId
    );
    const [warrantyPrice, setWarrantyPrice] = useState<string>(defaultValues.warrantyPrice);
    const [exteriorProtectionPrice, setExteriorProtectionPrice] = useState<string>(
        defaultValues.exteriorProtectionPrice
    );
    const [paintProtectionPrice, setPaintProtectionPrice] = useState<string>(
        defaultValues.paintProtectionPrice
    );

    const [productVariants, setProductVariants] = useState<ProductVariantType[]>(
        defaultValues.productVariants
    );

    const updateProductVariants = (product: ProductVariantType) => {
        setProductVariants((p) => [...p, product]);
    };

    return (
        <FinanceCalculatorContext.Provider
            value={{
                selectedWarrantyExtraId,
                setSelectedWarrantyExtraId,
                warrantyPrice,
                setWarrantyPrice,
                selectedPaintProtectionExtraId,
                paintProtectionPrice,
                setPaintProtectionPrice,
                setSelectedPaintProtectionExtraId,
                selectedExteriorProtectionExtraId,
                setSelectedExteriorProtectionExtraId,
                exteriorProtectionPrice,
                setExteriorProtectionPrice,
                updateProductVariants,
                productVariants,
            }}
        >
            {children}
        </FinanceCalculatorContext.Provider>
    );
};
